import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const UpgradeIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.875 13.325L16.1625 17.6125C16.5008 17.9508 17.0492 17.9508 17.3875 17.6125C17.7258 17.2742 17.7258 16.7258 17.3875 16.3875L11.7071 10.7071C11.3166 10.3166 10.6834 10.3166 10.2929 10.7071L4.6125 16.3875C4.27423 16.7258 4.27423 17.2742 4.6125 17.6125C4.95078 17.9508 5.49923 17.9508 5.8375 17.6125L10.125 13.325V21.125C10.125 21.6082 10.5168 22 11 22C11.4832 22 11.875 21.6082 11.875 21.125V13.325Z"
      />
      <path d="M18 11.0323C18 11.3226 17.9038 11.5161 17.7115 11.7097C17.3269 12.0968 16.75 12.0968 16.3654 11.7097L11.3543 6.67828C11.1588 6.48207 10.8412 6.48207 10.6457 6.67828L5.63461 11.7097C5.25 12.0968 4.67308 12.0968 4.28846 11.7097C3.90385 11.3226 3.90385 10.7419 4.28846 10.3548L10.3269 4.29032C10.7115 3.90323 11.2885 3.90323 11.6731 4.29032L17.7115 10.3548C17.9038 10.5484 18 10.7419 18 11.0323Z" />
    </Icon>
  );
};
